module.exports = __webpack_public_path__ + "img/faxian.fa4eb9e3.png";